import { useAdminApi } from "../../common/api/admin-api/useAdminApi";

export const useAdminLanguageApi = () => {
    const { getLanguageList, createLanguage } = useAdminApi();

    return {
        getLanguageList,
        createLanguage
    };
};
